<template>
  <IdentifyDblSelect previous-page-id="en026" next-page-id="en028">
    <template #wizard>
      <WizardGroup>
        <MainWizard :active-index="1" type="useridentity"></MainWizard>
      </WizardGroup>
    </template>
  </IdentifyDblSelect>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import IdentifyDblSelect from "@/components/fileupload/IdentifyDblSelect";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
export default {
  name: "En027",
  components: {
    MainWizard,
    WizardGroup,
    IdentifyDblSelect,
  },
  setup() {
    setMeta({
      title: "ご本人さま確認書類のご提出",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,本人確認書類",
    });
  },
};
</script>

<style lang="scss" scoped></style>
